module.exports = __webpack_public_path__ + "static/media/599.767(10).35ded733.pdf";